<template>
  <div class="container">
     <v-form ref="form2" v-model="validcambio" >
    <v-card>
      <v-card-title class="grey lighten-4 change-font" primary-title>Olvido de contraseña</v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col cols="12" xs="12" sm="12" md="12">
              <div class="text-center mb-3">
                <i
                  class="icon-user-lock icon-1x text-blue border-2 border-main rounded-round p-3 mb-3"
                ></i>
                <h3 class="text-title">Cambio de contraseña</h3>
                <span class="d-block text-muted mb-0">Modifique sus datos de acceso:</span>
              </div>
            </v-col>          
            <v-col cols="12" sm="12" md="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Nueva clave"
                    v-on:keyup.13="cambiar"
                    ref="nueva"
                    type="password"
                    v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!._%*?&])([A-Za-z\d$@!._%*?&]|[^ ]){8,}$/ }"
                    v-model="nuevaclave"
                    v-on="on"
                    data-vv-name="nueva"
                    :disabled="golvido === null"
                    :error-messages="errors.collect('nueva')"
                  ></v-text-field>
                </template>
                <span>
                  La nueva clave debe tener mínimo 8 caracteres, debe contener por lo menos una letra mayúscula,
                  <br />una letra minúscula, un número y uno de los siguientes caracteres: $@!._%*?&amp;
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Confirmar clave"
                v-on:keyup.13="cambiar"
                type="password"
                :disabled="golvido === null"
                v-model="confirmarclave"
                v-validate="'required|confirmed:nueva'"
                data-vv-name="confirmar"
                :error-messages="errors.collect('confirmar')"
              ></v-text-field>
            </v-col>
             
          </v-row>
        </v-container>
      </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>              
              <v-btn color="secondary" :disabled="!validcambio || golvido === null" v-on:click="cambiarclave">
                ENVIAR
                <v-icon right>icon-circle-right2</v-icon>
              </v-btn>
            </v-card-actions>
    </v-card>
     </v-form>
    <v-snackbar v-model="snack" :timeout="20000" :color="MesaggeInfo.color">      
      {{ this.MesaggeInfo.mensajeRespuesta }} {{this.MesaggeInfo.codigoRespuesta}}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "olvido",
  props: {
    proceso: Number,
    nombre: String
  },
  data() {
    return {
         nuevaclave: "",
      confirmarclave:"",
          snack: false,
         validcambio:false,      
      rules: {
        required: value => !!value || "Requerido",
        igual: () =>
          this.confirmarclave === this.nuevaclave || "Clave no válida"
      },
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      dictionary: {
        custom: {
          usuario: {
            required: () => "El nombre de usuario no puede estar en blanco"
          },
          clave: {
            required: () => "La clave no puede estar en blanco"
          },
          nueva: {
            required: () => "La nueva clave no puede estar en blanco",
            regex: () => "Valor de nueva clave no es válida"
          },
          confirmar: {
            required: () => "La confirmación de clave no puede estar en blanco",
            confirmed: () => "Las claves ingresadas no coinciden"
          }
        }
      }
    };
  },
  $_veeValidate: {
    validator: "new"
  },
  methods: {
    ...mapActions("usuario/", ["get_validarolvido","put_cambiarclaveolvido"]),
    cambio(item) {
      if (item.anterior === "") return item.valor;
      else return item.valor + "  <- " + item.anterior;
    },
    buscar() {
      this.cargando = true;
      this.put_auditoriatabla({
        data: { idregistro: this.registro },
        params: { idtabla: this.tabla.idtabla }
      });
    },
    cambiarclave() {
      this.golvido.clave = this.nuevaclave;
      this.put_cambiarclaveolvido(this.golvido);
    }
  },
  computed: {
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),  
    ...mapGetters("usuario", [ "golvido"]),  
    
  },
  created() {    
    let payload = { enlace: this.$route.params.enlace };
    this.get_validarolvido(payload);
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  watch: {
     ginformation() {
      this.MesaggeInfo = this.ginformation;      
      this.snack = true;
    }
  }
};
</script>
